import React from 'react'

import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons'
import {
  Box,
  Collapse,
  Flex,
  IconButton,
  Spacer,
  Text,
  useBoolean,
  useColorModeValue,
} from '@chakra-ui/react'

const ShowHideFormField = ({ heading, children, defaultShow }) => {
  const [showField, setShowField] = useBoolean(!!defaultShow)
  const [hovered, setHovered] = useBoolean(false)

  const hoverButtonBg = useColorModeValue('gray.200', 'gray.600')
  return (
    <Box onClick={e => e.stopPropagation()}>
      <Flex
        direction='row'
        cursor='pointer'
        align='center'
        onClick={setShowField.toggle}
        onMouseEnter={setHovered.on}
        onMouseLeave={setHovered.off}
      >
        {typeof heading === 'string' ? (
          <Text variant='subheading-blue'>{heading}</Text>
        ) : (
          heading
        )}
        <Spacer />
        <IconButton
          icon={showField ? <ChevronUpIcon /> : <ChevronDownIcon />}
          colorScheme='gray'
          bg={hovered && hoverButtonBg}
          size='md'
          fontSize='lg'
          variant='unstyled'
          borderRadius='full'
        />
      </Flex>

      <Collapse in={showField} p={0} m={0}>
        {showField ? children : null}
      </Collapse>
    </Box>
  )
}

export default ShowHideFormField
